import { useStoreState } from "easy-peasy"

function Header() {
	const HeaderCity = useStoreState((state) => state.HeaderCity)
	const HeaderUser = useStoreState((state) => state.HeaderUser)

	return (
		<header className="Header">
			{/* <span id="header_logo">
				<img src={logo} alt="Logo" style={{ width: "80px", height: "60px" }} />
			</span> */}
			<span id="header_title">{HeaderCity}</span>
			<span id="headerUser">{HeaderUser}</span>
		</header>
	)
}

export default Header
